import { render, staticRenderFns } from "./RrcvE_Details2.vue?vue&type=template&id=3896c14d"
import script from "./RrcvE_Details2.vue?vue&type=script&lang=js"
export * from "./RrcvE_Details2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports